/**
 * CRM / Approvals / Content shared constants + tiny helpers (technical ids are never translated here).
 */

export const STAGE_DOT = {
  sky: "bg-sky-400", slate: "bg-slate-400", emerald: "bg-emerald-500", amber: "bg-amber-400", indigo: "bg-indigo-500", violet: "bg-violet-500", rose: "bg-rose-400", orange: "bg-orange-400",
};
export const STAGE_COLOR_OPTIONS = Object.keys(STAGE_DOT);

export const LEAD_STATUSES = ["new", "contacted", "qualified", "unqualified", "converted", "lost"];
export const LEAD_SOURCE_TYPES = ["manual", "website", "form", "instagram", "facebook", "linkedin", "google_business", "referral", "prospecting", "event", "phone", "email", "post", "ad", "comment", "dm", "call", "campaign", "import", "other"];
export const TASK_STATUSES = ["todo", "in_progress", "done", "cancelled"];
export const PRIORITIES = ["low", "normal", "high", "urgent"];
export const INTERACTION_TYPES = ["call", "email", "meeting", "dm", "linkedin", "sms", "whatsapp", "comment", "message", "note"];
export const APPOINTMENT_STATUSES = ["scheduled", "completed", "cancelled", "no_show"];
export const OPPORTUNITY_STATUSES = ["open", "won", "lost"];

export const APPROVAL_STATUSES = ["pending_approval", "draft", "approved", "rejected", "cancelled"];
export const APPROVAL_ACTION_TYPES = ["publish_content", "send_outbound_message", "send_proposal", "meeting_followup", "automation_action", "crm_update", "other"];
export const APPROVAL_SOURCE_TYPES = ["content_item", "lead", "opportunity", "proposal", "meeting_followup", "outbound_message", "campaign", "automation", "other"];
/** Agents prepared visually for the inbox filters (all stay plan_only in step 2.2). */
export const APPROVAL_AGENTS = ["CONTENT_AGENT", "INTELLIGENCE_AGENT", "SALES_AGENT", "MEETINGS_AGENT", "PROPOSALS_AGENT", "COMMERCE_AGENT", "ORCHESTRATOR"];

export const CONTENT_STATUSES = ["draft", "pending_approval", "approved", "scheduled", "cancelled"];
export const CONTENT_PLATFORMS = ["instagram", "facebook", "linkedin", "tiktok", "google_business", "pinterest", "newsletter", "blog"];
export const CONTENT_FORMATS = ["post", "carousel", "reel", "story", "video_script", "article", "gbp_post"];

/** Build a query string, skipping empty values. */
export function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && v !== "__all__") search.set(k, String(v));
  });
  const s = search.toString();
  return s ? `?${s}` : "";
}

/** <input type="datetime-local"> value -> ISO string (UTC) or null. */
export function localToIso(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

/** ISO -> <input type="datetime-local"> value. */
export function isoToLocal(value) {
  if (!value) return "";
  const d = new Date(value);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** ISO -> <input type="date"> value. */
export function isoToDate(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

export const ALL = "__all__";

export function contactName(c) {
  if (!c) return "";
  return `${c.first_name || ""} ${c.last_name || ""}`.trim();
}

export function parseTags(text) {
  return String(text || "").split(",").map((s) => s.trim()).filter(Boolean);
}

export function cleanPayload(obj) {
  const out = {};
  Object.entries(obj).forEach(([k, v]) => {
    if (v === "" || v === undefined) return;
    out[k] = v;
  });
  return out;
}
